export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: "up" | "down" | "new";
}

export const hotList: HotItem[] = [
  { rank: 1, title: "顶流演唱会“半开麦”争议持续发酵", tag: "假唱红黑", heat: "982万", trend: "up" },
  { rank: 2, title: "热播剧番位海报疑被“二番”冲上热搜", tag: "粉圈大战", heat: "901万", trend: "new" },
  { rank: 3, title: "一线女星二度回应合约细节再引热议", tag: "合约风波", heat: "846万", trend: "up" },
  { rank: 4, title: "考古旧照被删反被扒出更多“黑历史”", tag: "考古回放", heat: "721万", trend: "new" },
  { rank: 5, title: "综艺恶意剪辑争议再添新“证据”", tag: "综艺幕后", heat: "668万", trend: "up" },
  { rank: 6, title: "“塌房补偿计划”被曝幕后资本角力", tag: "资本内幕", heat: "589万", trend: "down" },
  { rank: 7, title: "粉丝应援跑路疑云牵出粉圈乱象", tag: "粉圈大战", heat: "512万", trend: "up" },
  { rank: 8, title: "海外热瓜“版权翻唱”风波波及内娱", tag: "海外瓜田", heat: "431万", trend: "new" },
];

export const marqueeItems: string[] = [
  "顶流“半开麦”争议登上热搜",
  "番位海报之争引粉丝互撕",
  "女星二度回应合约细节",
  "考古旧照被删反被扒出更多旧账",
  "综艺“剧本”再添新证据",
  "“塌房补偿计划”牵出资本角力",
  "应援跑路疑云引粉圈自检",
];